import React from 'react';
import { Container } from 'react-bootstrap';
import { site } from '../data/site';

const Terms: React.FC = () => (
  <Container className="py-5">
    <h1 className="mb-4">Terms of Use</h1>

    <p>
      By using {site.domain} you agree to the terms below. If you do not agree, please do not use
      the site.
    </p>

    <h3 className="h5 mt-4">1. Information on This Site</h3>
    <p>
      Content here is provided for general information about Art on the Lake and its past festivals.
      Dates, sponsors, and other details describe events that have already happened and may not
      reflect current plans.
    </p>

    <h3 className="h5 mt-4">2. Photographs and Artwork</h3>
    <p>
      Photographs on this site were taken at Art on the Lake Festivals and remain the property of
      Art on the Lake or the individual photographers and artists shown. Please do not reuse them
      commercially without asking us first.
    </p>

    <h3 className="h5 mt-4">3. Third-Party Links</h3>
    <p>
      We link to sponsors, partners, and social media for convenience. We are not responsible for
      the content of those sites.
    </p>

    <h3 className="h5 mt-4">4. Changes</h3>
    <p>
      We may update this site and these terms at any time.
    </p>

    <h3 className="h5 mt-4">5. Contact</h3>
    <p>
      Questions? Email <a href={`mailto:${site.email}`}>{site.email}</a> or call{' '}
      <a href={site.phoneHref}>{site.phone}</a>.
    </p>
  </Container>
);

export default Terms;
